/**
 * Created by lei_sun on 2019/7/30.
 */
// import ProjectConfig from '../project.config'
import { Bridge } from '@iskytrip/sdk'

// import CommonUtil from './UtilCommon'
// import DomUtil from './dom'
// import * as utilsConstants from './constants'

export default {
	// ..._.Object.assign({}, UtilDevice.__proto__)
	// isInIOS: function () {
	//     let type = false;
	//     if (typeof window !== "undefined") {
	//         if (this.isInApp()) {
	//             type = !!navigator.userAgent.match(/iphone|ipad|ipod/i)
	//         }
	//     }
	//     return type;
	// },
	// isIphoneX: function () {
	//     let type = false;
	//     if (typeof window !== "undefined") {
	//         const app = this.isInApp();
	//         if (app) {
	//             type = /isiphonex/.test(navigator.userAgent.toLowerCase())
	//         }
	//         if (app && !type) {
	//             const clientHeight = document.documentElement.clientHeight || window.pageYOffset || document.body.clientHeight;
	//             if (clientHeight > 800 && clientHeight < 1000) {
	//                 type = true;
	//             }
	//         }
	//     }
	//     return type;
	// },
	// isInApp: function () {
	//     return !!navigator.userAgent.match(new RegExp(ProjectConfig.vendor, 'i'));
	// },
	// isInWechat: function () {
	//     return !!navigator.userAgent.match(/micromessenger/i);
	// },
	// appSetSignalBarColor: function (color) { // 设置信号栏文字颜色 (color: white or black)
	//     if (this.isInApp()) {
	//         if (!color) {
	//             color = 'black'
	//         }

	//         BridgeUtil.invoke("AirportSignalBarColor", { color: color }, (response) => {
	//             //alert(JSON.stringify(response))
	//         });
	//     }
	// },
	// appSetSignalBarBackgroundColor: function (backgroundColor) { // 设置信号栏背景色值
	//     if (this.isInApp()) {
	//         if (!backgroundColor) {
	//             backgroundColor = 'transparent'
	//         }

	//         let flag = false;
	//         if (this.isInIOS()) {
	//             flag = true;
	//         } else {
	//             if (backgroundColor != 'transparent' && backgroundColor.indexOf('rgb') == -1) {
	//                 flag = true;
	//             }
	//         }

	//         if (flag) {
	//             BridgeUtil.invoke("AirportSignalBarBackgroundColor", { backgroundColor: backgroundColor }, (response) => {
	//                 //alert(JSON.stringify(response))
	//             });
	//         }
	//     }
	// },
	// appViewBack: function (params) { // 页面回退
	//     if (this.isInApp()) {
	//         if (!params) {
	//             params = {};
	//         }

	//         BridgeUtil.invoke("AirportViewBack", { params: params }, (response) => {
	//             //alert(JSON.stringify(response))
	//         });
	//     }
	// },
	// appOpenWebView: function (url) { // 新开 WebView
	//     if (this.isInApp()) {
	//         if (!url) {
	//             url = window.location.href;
	//         }

	//         BridgeUtil.invoke("AirportOpenWebView", { url: url }, (response) => {
	//             //alert(JSON.stringify(response))
	//         });
	//     }
	// },
	// appOpenPage: function (pageName, params) { // 打开 Native 页面
	//     if (this.isInApp()) {
	//         if (!pageName) {
	//             pageName = '';
	//         }

	//         if (!params) {
	//             params = {};
	//         }

	//         //alert('AirportOpenPage: ' + pageName);
	//         BridgeUtil.invoke("AirportOpenPage", { pageName: pageName, params: params }, (response) => {
	//             //console.log('AirportOpenPage', pageName, params, JSON.stringify(response))
	//             //alert('AirportOpenPage_response: ' + response);
	//         });
	//     }
	// },
	// appCallPhone: function (num) { // 拨打电话
	//     if (this.isInApp()) {
	//         if (num) {
	//             BridgeUtil.invoke("AirportCallPhone", { num: num }, (response) => {
	//                 //alert(JSON.stringify(response))
	//             });
	//         }
	//     }
	// },
	// appIsInApp: function (callback) { // 是否在 APP 当中
	//     let storageAppInAPP = DomUtil.getLocalStorage(utilsConstants.STORAGE_APP_INAPP);
	//     if (storageAppInAPP) {
	//         storageAppInAPP = parseInt(storageAppInAPP, 10);
	//         return callback && callback(storageAppInAPP);
	//     }

	//     BridgeUtil.invoke("AirportInTheApp", {}, (response) => {
	//         //alert(JSON.stringify(response))
	//         if (response && response.InTheApp == 1) {
	//             DomUtil.setLocalStorage(utilsConstants.STORAGE_APP_INAPP, 1)
	//             callback && callback(true);
	//         }
	//         else {
	//             DomUtil.setLocalStorage(utilsConstants.STORAGE_APP_INAPP, 0)
	//             callback && callback(false);
	//         }
	//     });
	// },
	// appGetVersion: function (callback) { // 获取 APP 版本号
	//     if (this.isInApp()) {
	//         let storageAppVersion = DomUtil.getLocalStorage(utilsConstants.STORAGE_APP_VERSION);
	//         if (storageAppVersion) {
	//             return callback && callback(storageAppVersion);
	//         }

	//         BridgeUtil.invoke("AirportAppVersion", {}, (response) => {
	//             //alert(JSON.stringify(response))
	//             if (response && response.appVersion) {
	//                 const appVersion = response.appVersion;
	//                 DomUtil.setLocalStorage(utilsConstants.STORAGE_APP_VERSION, appVersion)
	//                 callback && callback(appVersion);
	//             } else {
	//                 callback && callback();
	//             }
	//         });
	//     } else {
	//         callback && callback();
	//     }
	// },
	// appGetChannel: function (callback) { // 获取 APP 渠道
	//     if (this.isInApp()) {
	//         let storageAppChannel = DomUtil.getLocalStorage(utilsConstants.STORAGE_APP_CHANNEL);
	//         if (storageAppChannel) {
	//             return callback && callback(storageAppChannel);
	//         }

	//         BridgeUtil.invoke("AirportAppChannel", {}, (response) => {
	//             //alert(JSON.stringify(response))
	//             if (response && response.appChannel) {
	//                 const appChannel = response.appChannel;
	//                 DomUtil.setLocalStorage(utilsConstants.STORAGE_APP_CHANNEL, appChannel)
	//                 callback && callback(appChannel);
	//             } else {
	//                 callback && callback();
	//             }
	//         });
	//     } else {
	//         callback && callback();
	//     }
	// },
	// appGetLocation: function (callback) { // 获取定位经纬度
	//     if (this.isInApp()) {
	//         BridgeUtil.invoke("AirportLocation", {}, (response) => {
	//             //alert(JSON.stringify(response))
	//             if (response) {
	//                 callback && callback(response);
	//             } else {
	//                 callback && callback();
	//             }
	//         });
	//     } else {
	//         CommonUtil.getH5Location(callback);
	//     }
	// },
	appLocationPermissions: function(callback) {
		// 打开设置定位权限
		if (this.isInApp()) {
			Bridge.callHandler('AirportLocationPermissions', {}, (response) => {
				//alert(JSON.stringify(response))
				if (response) {
					callback && callback(response)
				} else {
					callback && callback()
				}
			})
		} else {
			callback && callback()
		}
	},
	// appGetNavHeight: function (callback) { // 获取导航栏高度
	//     if (this.isInApp()) {
	//         let storageAppNavHeight = DomUtil.getLocalStorage(utilsConstants.STORAGE_APP_NAV_HEIGHT);
	//         if (storageAppNavHeight) {
	//             storageAppNavHeight = parseInt(storageAppNavHeight, 10)
	//             return callback && callback(storageAppNavHeight);
	//         }

	//         BridgeUtil.invoke("AirportNavHeight", {}, (response) => {
	//             //alert(JSON.stringify(response))
	//             if (response && response.navHeight) {
	//                 const navHeight = response.navHeight;
	//                 DomUtil.setLocalStorage(utilsConstants.STORAGE_APP_NAV_HEIGHT, navHeight);
	//                 callback && callback(navHeight);
	//             } else {
	//                 callback && callback();
	//             }
	//         });
	//     } else {
	//         callback && callback();
	//     }
	// },
	// appGetSignalBarHeight: function (callback) {  // 获取信号栏高度
	//     if (this.isInApp()) {
	//         let storageAppSignalBarHeight = DomUtil.getLocalStorage(utilsConstants.STORAGE_APP_SIGNAL_BAR_HEIGHT);
	//         if (storageAppSignalBarHeight) {
	//             //alert('storageAppSignalBarHeight: ' + storageAppSignalBarHeight);
	//             storageAppSignalBarHeight = parseInt(storageAppSignalBarHeight, 10);
	//             return callback && callback(storageAppSignalBarHeight);
	//         }

	//         BridgeUtil.invoke("AirportSignalBarHeight", {}, (response) => {
	//             //alert('AirportSignalBarHeight: ' + JSON.stringify(response));

	//             if (response && response.height) {
	//                 const appSignalBarHeight = response.height;
	//                 DomUtil.setLocalStorage(utilsConstants.STORAGE_APP_SIGNAL_BAR_HEIGHT, appSignalBarHeight);
	//                 callback && callback(appSignalBarHeight);
	//             } else {
	//                 callback && callback();
	//             }
	//         });
	//     } else {
	//         callback && callback();
	//     }
	// },
	// appSetNativeStorage: function (key, data, callback) { // 设置 Native 本地存储
	//     if (this.isInApp()) {
	//         if (key != '') {
	//             BridgeUtil.invoke("AirportSetNativeStorage", { key: 'js_' + key, data: JSON.stringify(data) }, (response) => {
	//                 //alert(JSON.stringify(response))
	//                 if (response && response.result) {
	//                     callback && callback(true);
	//                 } else {
	//                     callback && callback(false);
	//                 }
	//             });
	//         }
	//     } else {
	//         if (key != '') {
	//             DomUtil.setLocalStorage(key, JSON.stringify(data));
	//         }
	//         callback && callback();
	//     }
	// },
	// appGetNativeStorage: function (key, callback) { // 获取 Native 本地存储
	//     if (this.isInApp()) {
	//         if (key != '') {
	//             BridgeUtil.invoke("AirportGetNativeStorage", { key: 'js_' + key }, (response) => {
	//                 //alert(JSON.stringify(response))
	//                 if (response && response.result) {
	//                     if (response.data)
	//                         callback && callback(JSON.parse(response.data));
	//                     else
	//                         callback && callback();
	//                 } else {
	//                     callback && callback();
	//                 }
	//             });
	//         }
	//     } else {
	//         let storageResult = null;
	//         if (key != '') {
	//             storageResult = DomUtil.getLocalStorage(key);
	//             if (storageResult) {
	//                 storageResult = JSON.parse(storageResult)
	//             }
	//         }
	//         callback && callback(storageResult);
	//     }
	// },
	// appDeleteNativeStorage: function (key, callback) { // 删除 Native 本地存储
	//     if (this.isInApp()) {
	//         if (key != '') {
	//             BridgeUtil.invoke("AirportDeleteNativeStorage", { key: 'js_' + key }, (response) => {
	//                 //alert(JSON.stringify(response))
	//                 if (response && response.result) {
	//                     callback && callback(true);
	//                 } else {
	//                     callback && callback(false);
	//                 }
	//             });
	//         }
	//     } else {
	//         if (key != '') {
	//             DomUtil.remLocalStorage(key);
	//         }
	//         callback && callback();
	//     }
	// },
	// appBanRightGestures: function (isBanGestures, callback) { // 禁止当前页面右滑返回
	//     if (this.isInApp()) {
	//         BridgeUtil.invoke("AirportBanRightGestures", { isBanGestures: isBanGestures }, callback);
	//     } else {
	//         callback && callback()
	//     }
	// },
	// appGetHeader: function (callback) {  // 获取 Native 封装的网络 Header
	//     if (this.isInApp()) {
	//         BridgeUtil.invoke("AirportHeader", {}, (response) => {
	//             //alert(JSON.stringify(response))
	//             callback && callback(response)
	//         });
	//     } else {
	//         callback && callback()
	//     }
	// },
	// appGetToken: function (callback) {  // 获取 Native 提供的 Token 及 userId
	//     if (this.isInApp()) {
	//         BridgeUtil.invoke("AirportToken", {}, (response) => {
	//             //console.log('appGetToken_response', response)
	//             //alert('AirportToken_response: ' + JSON.stringify(response))

	//             if (response.result == 1)
	//                 callback && callback(response)
	//             else
	//                 callback && callback()
	//         });
	//     } else {
	//         callback && callback()
	//     }
	// },
	// appGetAuthCode: function (callback) {  // 获取 Native 提供的 携程联合登陆 AuthCode
	//     if (this.isInApp()) {
	//         BridgeUtil.invoke("AirportAuthCode", {}, (response) => {
	//             //alert(JSON.stringify(response))
	//             if (response.result == 1)
	//                 callback && callback(response.AuthCode)
	//             else
	//                 callback && callback();
	//         });
	//     } else {
	//         callback && callback()
	//     }
	// },
	appShowToast: function(msg) {
		// 获取 Native 提供的 Toast 方法
		if (this.isInApp()) {
			if (msg !== '' && msg !== undefined) {
				let msgTime = 0
				if (msg.length > 5) {
					msgTime = 1
				}

				Bridge.callHandler('AirportToast', { msg: msg, msgTime: msgTime }, (response) => {
					//alert(JSON.stringify(response))
				})

				// BridgeUtil.invoke("AirportToast", { msg: msg, msgTime: msgTime }, (response) => {
				//     //alert(JSON.stringify(response))
				// });
			}
		}
	},
	iosPenetrate() {
		const str = navigator.userAgent.toLowerCase()
		const ver = str.match(/cpu iphone os (.*?) like mac os/)
		if (!ver) {
			return true
		} else {
			const num = ver[1].replace(/_/g, '.')
			const numList = num.split('.')
			if (numList[0] - 11 < 0) {
				return false
			} else {
				return true
			}
		}
	},
	// pageAppear: function (pageName, callback) {  // JS 提供给 Native 调用方法 页面呈现
	//     if (!pageName)
	//         pageName = '';

	//     if (this.isInApp()) {
	//         BridgeUtil.register("AirportNextAppear", (response) => {
	//             //alert(pageName + '--AirportNextAppear')
	//             console.log(pageName, 'AirportNextAppear')
	//             callback && callback()
	//         });
	//     } else {
	//         callback && callback()
	//     }
	// },
	// pageDisAppear: function (pageName, callback) {  // JS 提供给 Native 调用方法 页面消失
	//     if (!pageName)
	//         pageName = '';

	//     if (this.isInApp()) {
	//         BridgeUtil.register("AirportNextDisAppear", (response) => {
	//             //alert(pageName + '--AirportNextDisAppear')
	//             console.log(pageName, 'AirportNextDisAppear')
	//             callback && callback()
	//         });
	//     } else {
	//         callback && callback()
	//     }
	// },
	// pageGetBackParams: function (pageName, callback) {  // JS 提供给 Native 调用方法 获取上一页面返回的参数
	//     if (!pageName)
	//         pageName = '';

	//     if (this.isInApp()) {
	//         BridgeUtil.register("AirportNextGetBackParams", (response) => {
	//             //alert(pageName + '--AirportNextGetBackParams')
	//             console.log(pageName, 'AirportNextGetBackParams')
	//             callback && callback(response)
	//         });
	//     } else {
	//         callback && callback()
	//     }
	// },
	// pageGetPayResult: function (callback) {  // JS 提供给 Native 调用方法 获取支付方式及结果
	//     if (this.isInApp()) {
	//         BridgeUtil.register("AirportNextGetPayResult", (response) => {
	//             //alert(pageName + '--AirportNextGetPayResult')
	//             console.log('AirportNextGetPayResult')
	//             callback && callback(response)
	//         });
	//     } else {
	//         callback && callback()
	//     }
	// }
}
